import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Company',
    field: 'companyId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'companyId',
      fk: 'companyId',
      namespace: 'company',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Division',
    field: 'divisionId',
    // displayValue: row => {
    //   return `${row.division.name}`
    // },
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'divisionId',
      fk: 'divisionId',
      namespace: 'division',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
